import React, { useContext } from "react";
import { TeamsContext } from "../../App";

function Team() {
  const TeamsList = useContext(TeamsContext);
  return (
    <div className="w-full py-10 flex flex-col justify-center items-center">
      <div className="w-full pl-2 text-3xl md:text-6xl">Meet the Team</div>
      <div className="w-11/12 py-5 gap-x-5 flex">
        {TeamsList.map((member) => {
          return (
            <div key={member.id} className="max-w-64 p-1 flex flex-col bg-cyan-600 rounded-lg">
              <img
                src={member.img}
                alt=""
                className="object-cover"
                width={250}
              />
              <p className="text-xl pt-2 px-1">{member.name}</p>
              <p className="text-xl px-1">{member.title}</p>
            </div>
          );
        })}
      </div>
    </div>
  );
}

export default Team;
